module.exports = __webpack_public_path__ + "img/024.b3996585.jpg";